import { createSelector } from '@reduxjs/toolkit';

import { FormStepId } from 'shared/config/formStepId';

import {
  selectAdditionalInfo,
  selectContactsInfo,
  selectCreditPurposeInfo,
  selectPassportInfo,
  selectWorkplaceInfo,
} from 'src/client/entities/creditForm';

export const defaultStepperConfigSelector = createSelector(
  selectCreditPurposeInfo,
  selectContactsInfo,
  selectPassportInfo,
  selectWorkplaceInfo,
  selectAdditionalInfo,
  // eslint-disable-next-line max-params
  (creditPurposeInfoForm, contactsInfoForm, passportInfoForm, workplaceInfoForm, additionalInfoForm) => ({
    [FormStepId.CreditPurposeInfo]: creditPurposeInfoForm,
    [FormStepId.ContactsInfo]: contactsInfoForm,
    [FormStepId.PassportInfo]: passportInfoForm,
    [FormStepId.WorkplaceInfo]: workplaceInfoForm,
    [FormStepId.AdditionalInfo]: additionalInfoForm,
  }),
);

export const vitrinsStepperConfigSelector = createSelector(
  selectCreditPurposeInfo,
  // eslint-disable-next-line max-params
  (creditPurposeInfoForm) => ({
    [FormStepId.CreditPurposeInfo]: creditPurposeInfoForm,
  }),
);
